<template>
    <div class="home">
        <swiper :options="homeSwiperOpts" class="home-swiper">
            <swiper-slide>
                <section class="banner">
                    <swiper :options="bannerSwiperOpts" ref="bannerSwiper" v-if="bannerImgs.length>0"
                            style="height: 100%">
                        <swiper-slide v-for="(item,index) in bannerImgs" :key="index" class="banner-item"
                                      style="height: 100%">
                            <a :href="item.url" v-if="item.url" :style="{backgroundImage:'url('+item.picture+')'}"
                               style="width: 100%;height: 100%;background-position: center;background-size: cover;"></a>
                            <div :src="item.imgUrl" v-else :style="{backgroundImage:'url('+item.picture+')'}"
                                 style="width: 100%;height: 100%;background-position: center;background-size: cover;"></div>
                        </swiper-slide>
                        <div slot="pagination" class="swiper-pagination banner-swiper-pagination"></div>
                    </swiper>
                </section>
            </swiper-slide>
            <swiper-slide>
                <section class="company-profile">
                    <div class="video-box">
                        <video ref="video" x-webkit-airplay="allow" playsinline >
                            <source :src="companyProfile.videoUrl" type="video/mp4">
                        </video>
                        <div :class="videoPosterVisible" class="video-poster"></div>
                    </div>
                    <div class="desc-box ani" swiper-animate-effect="fadeInDown" swiper-animate-duration="0.5s"
                         swiper-animate-delay="0.3s">
                        <div class="inner">
                            <div class="ani" swiper-animate-effect="fadeInDown" swiper-animate-duration="0.5s"
                                 swiper-animate-delay="1s">
                                <div class="title" v-html="companyProfile.title"></div>
                                <div>
                                    <img src="../../assets/icon/line.png" alt="" class="line">
                                </div>
                            </div>
                            <div class="desc ani" v-html="companyProfile.desc" swiper-animate-effect="fadeInUpS"
                                 swiper-animate-duration="0.6s" swiper-animate-delay="1.4s"></div>
                        </div>
                    </div>
                </section>
            </swiper-slide>
            <swiper-slide>
                <section class="products">
                    <div class="container">
                        <div class="section-title">
                            <div class="ani" swiper-animate-effect="fadeInDown" swiper-animate-duration="0.5s"
                                 swiper-animate-delay="0.5s">
                                <div class="title">{{$t(products.title)}}</div>
                                <img src="../../assets/icon/line.svg" alt="" class="line">
                            </div>
                            <div class="desc ani" v-html="$t(products.desc)" swiper-animate-effect="fadeInUpS"
                                 swiper-animate-duration="0.6s" swiper-animate-delay="1s"></div>
                        </div>
                        <ul class="product-list">
                            <li class="product-item ani" v-for="(item, index) in products.items" :key="index"
                                swiper-animate-effect="fadeInUpS" swiper-animate-duration="0.8s"
                                :swiper-animate-delay="1.3+index*0.2 +'s'">
                                <router-link :to="item.url">
                                    <img :src="item.imgUrl" alt="">
                                    <div class="mask"></div>
                                    <div class="name">{{$t(item.name)}}</div>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </section>
            </swiper-slide>
            <swiper-slide>
                <section class="investor-relations">
                    <div class="container">
                        <div class="section-title ani" swiper-animate-effect="fadeInDown" swiper-animate-duration="0.5s"
                             swiper-animate-delay="0.5s">
                            <div class="title">{{$t(investorRelations.title)}}</div>
                            <img src="../../assets/icon/line.svg" alt="" class="line">
                        </div>
                        <div class="top-box ani" swiper-animate-effect="fadeInUpS" swiper-animate-duration="0.6s"
                             swiper-animate-delay="1s">
                            <div class="chart-box">
                                <img src="http://image.sinajs.cn/newchart/min/n/sz002048.gif" alt="">
                            </div>
                            <div class="info-box" v-if="investorRelations.elements">
                                <div class="name">{{$t(investorRelations.name)}}</div>
                                <div class="now"
                                     :class="investorRelations.elements[1]<investorRelations.elements[3]?'up':'down'">
                                    {{investorRelations.elements[3] | returnFloat}}
                                </div>
                                <div class="row">
                                    <div class="item">
                                        <div class="key">{{$t(investorRelations.volume)}}</div>
                                        <div class="value">{{investorRelations.elements[8]/10000 | returnFloat}}</div>
                                    </div>
                                    <div class="item">
                                        <div class="key">{{$t(investorRelations.dayHigh)}}</div>
                                        <div class="value">{{investorRelations.elements[4] | returnFloat}}</div>
                                    </div>
                                    <div class="item">
                                        <div class="key">{{$t(investorRelations.dayOpen)}}</div>
                                        <div class="value">{{investorRelations.elements[1] | returnFloat}}</div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="item">
                                        <div class="key">{{$t(investorRelations.turnover)}}</div>
                                        <div class="value">{{investorRelations.elements[9]/10000 | returnFloat}}</div>
                                    </div>
                                    <div class="item">
                                        <div class="key">{{$t(investorRelations.dayLow)}}</div>
                                        <div class="value">{{investorRelations.elements[5] | returnFloat}}</div>
                                    </div>
                                    <div class="item">
                                        <div class="key">{{$t(investorRelations.yesterdayClose)}}</div>
                                        <div class="value">{{investorRelations.elements[2] | returnFloat}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bottom-box">
                            <div class="left-box ani" swiper-animate-effect="fadeInUpS" swiper-animate-duration="0.6s"
                                 swiper-animate-delay="1.2s">
                                <div class="title">{{$t('home.最新公告')}}</div>
                                <Button size="small" type="primary"
                                        to="http://www.szse.cn/disclosure/listed/notice/index.html?stock=002048&name=%E5%AE%81%E6%B3%A2%E5%8D%8E%E7%BF%94"
                                        target="_blank"
                                        class="btn-more">{{$t('common.查看更多')}}
                                </Button>
                            </div>
                            <div class="right-box ani" swiper-animate-effect="fadeInUpS" swiper-animate-duration="0.6s"
                                 swiper-animate-delay="1.5s">
                                <div class="title">{{$t('home.公司治理')}}</div>
                                <Button size="small" type="primary" to="/corporateGovernance" class="btn-more">
                                    {{$t('common.查看更多')}}
                                </Button>
                            </div>
                        </div>
                    </div>
                </section>
            </swiper-slide>
            <swiper-slide>
                <section class="news">
                    <div class="bg"></div>
                    <div class="inner">
                        <div class="section-title ani" swiper-animate-effect="fadeInDown" swiper-animate-duration="0.5s"
                             swiper-animate-delay="0.5s">
                            <div class="title">{{$t(news.title)}}</div>
                            <img src="../../assets/icon/line.svg" alt="" class="line">
                        </div>
                        <div class="top-news ani" swiper-animate-effect="fadeInUpS" swiper-animate-duration="0.6s"
                             swiper-animate-delay="1s" :v-if="news.topNews.picture">
                            <div class="img" :style="{backgroundImage:'url('+ news.topNews.picture+')'}"></div>
                            <div class="bar">
                                <div class="title-box">
                                    <span class="title">{{news.topNews.title}}</span>
                                    <span class="date" v-if="news.topNews.release_time">{{news.topNews.release_time.slice(0,10)}}</span>
                                </div>
                                <div class="subtitle">{{news.topNews.sub_title}}</div>
                                <Button size="small" type="primary"
                                        :to="'/newsDetail?id='+news.topNews.id" target="_blank"
                                        class="btn-more">
                                    {{$t('common.查看更多')}}
                                </Button>
                            </div>
                        </div>
                        <div class="bottom-list  ani" swiper-animate-effect="fadeInUpS" swiper-animate-duration="0.6s"
                             swiper-animate-delay="1.2s">
                            <swiper :options="newsSwiperOpts" ref="bannerSwiper" v-if="news.bottomNews.length>0">
                                <swiper-slide v-for="(item,index) in news.bottomNews" :key="index">
                                    <div class="left"
                                         :style="{backgroundImage: 'url('+item.picture+')'}"></div>
                                    <div class="right">
                                        <div class="title-box">
                                            <div class="title">{{item.title}}</div>
                                            <div class="date">{{item.release_time.slice(0,10)}}</div>
                                        </div>
                                        <div class="subtitle">{{item.sub_title}}</div>
                                        <Button size="small" type="primary"
                                                :to="item.content?'/newsDetail?id='+item.id:item.url"
                                                target="_blank"
                                                class="btn-more">
                                            {{$t('common.查看更多')}}
                                        </Button>
                                    </div>
                                </swiper-slide>
                            </swiper>
                            <div>
                                <div class="icon-left">
                                    <Icon type="ios-arrow-back"/>
                                </div>
                                <div class="icon-right">
                                    <Icon type="ios-arrow-forward"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </swiper-slide>
            <swiper-slide class="home-footer-wrapper">
                <Footer></Footer>
            </swiper-slide>
            <div slot="pagination" class="home-swiper-pagination"></div>
        </swiper>
    </div>
</template>

<script>
    import * as swiperAni from '../../assets/js/swiper.animate.min'
    import '../../assets/css/animate.min.css'
    import {mapState} from 'vuex'
    import Footer from '@/components/footer/Index.vue'

    let vm, homeVideo, homeVideoPlayer;
    export default {
        data() {
            return {
                videoPosterVisible: 'visible',
                homeSwiperOpts: {
                    direction: 'vertical',
                    mousewheel: true,
                    slidesPerView: 'auto',
                    // speed:500,

                    pagination: {
                        el: '.home-swiper-pagination',
                        clickable: true,
                    },
                    on: {
                        init: function () {
                            swiperAni.swiperAnimateCache(this); //隐藏动画元素
                            swiperAni.swiperAnimate(this); //初始化完成开始动画
                        },

                        slideChangeTransitionEnd: function () {
                            if (this.activeIndex == 1) {
                                setTimeout(() => {
                                    vm.videoPosterVisible = '';
                                }, 3000);
                                // homeVideoPlayer.ready(function () {
                                    setTimeout(() => {
                                        homeVideoPlayer.play();
                                        setTimeout(()=>{
                                            if(homeVideoPlayer.pause){
                                                console.log('xxxxx');
                                                homeVideoPlayer.play();
                                            }
                                        },100)
                                    }, 3000);
                                // });
                            }
                            swiperAni.swiperAnimate(this); //每个slide切换结束时也运行当前slide动画
                            //this.slides.eq(this.activeIndex).find('.ani').removeClass('ani'); 动画只展现一次，去除ani类名
                        }
                    }
                },
                bannerSwiperOpts: {
                    loop: true,
                    effect: 'fade',
                    speed: 800,
                    observer: true,
                    observeParents: true,
                    autoplay: {
                        delay: 5000,
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                },
                bannerImgs: [],
                companyProfile: {},
                products: {
                    title: 'home.products.title',
                    desc: 'home.products.desc',
                    items: [{
                        url: '/productDetail?typeId=1',
                        name: 'common.装饰条',
                        imgUrl: require('../../assets/img/home/products/1.jpg')
                    }, {
                        url: '/productDetail?typeId=2',
                        name: 'common.内外饰件',
                        imgUrl: require('../../assets/img/home/products/2.jpg')
                    }, {
                        url: '/productDetail?typeId=3',
                        name: 'common.车身金属件',
                        imgUrl: require('../../assets/img/home/products/3.jpg')
                    }, {
                        url: '/productDetail?typeId=4',
                        name: 'common.车身电子',
                        imgUrl: require('../../assets/img/home/products/4.jpg')
                    }]
                },
                investorRelations: {
                    title: 'common.投资者关系',
                    name: 'home.investorRelations.name',
                    dayHigh: 'home.investorRelations.dayHigh',
                    dayLow: 'home.investorRelations.dayLow',
                    dayOpen: 'home.investorRelations.dayOpen',
                    volume: 'home.investorRelations.volume',
                    turnover: 'home.investorRelations.turnover',
                    yesterdayClose: 'home.investorRelations.yesterdayClose',
                },
                news: {
                    title: 'home.news.title',
                    newsList: [],
                    topNews: {},
                    bottomNews: []
                },
                pdfList: [],
                newsSwiperOpts: {
                    loop: true,
                    slidesPerView: 2,
                    spaceBetween: 25,
                    navigation: {
                        nextEl: '.icon-right',
                        prevEl: '.icon-left',
                    },
                }

            }
        },
        computed: mapState({
            language: state => state.base.language
        }),
        components: {
            Footer
        },
        methods: {
            getPageData() {
                this.$api.home.getBannerList({
                    channel:1
                }).then(res => {
                    this.bannerImgs = res || [];
                });

                this.$api.about.getPageData({}).then(res => {
                    this.companyProfile = {
                        title: res.title,
                        desc: res.content,
                        videoUrl: res.videoUrl,
                        videoImg: require('../../assets/img/home/poster.jpg')
                    };
                    this.$nextTick(() => {
                        homeVideo = this.$refs.video;
                        homeVideoPlayer = this.$video(homeVideo, {
                            controls: false,
                            // muted: true,
                            preload: "auto",
                            loop: true,
                        });
                    })
                });
                this.$api.news.getNewsList({
                    pageSize: 10,
                    pageNo: 0,
                    type: 2
                }).then(res => {
                    const items = res.rows || [];
                    this.news.topNews = items[0];
                    this.news.bottomNews = items.slice(1);
                })
            }
        },
        watch: {
            language() {

            }
        },
        created() {
            vm = this;
            this.$nextTick(() => {
                this.investorRelations.elements = hq_str_sz002048.split(",");
            });
        },
        activated() {
            this.getPageData();
        }
    }
</script>

<style lang="scss">
    .home-swiper {
        .swiper-wrapper {
            transition-timing-function: ease-in-out;
        }
    }

    .banner-swiper-pagination {
        bottom: vh(50) !important;

        .swiper-pagination-bullet {
            background-color: transparent;
            opacity: 1;
            border: 1px solid #fff;
            width: vh(14);
            height: vh(14);
            margin: 0 vh(20) !important;

            &.swiper-pagination-bullet-active {
                background: #fff;
            }
        }
    }

    .home-swiper-pagination {
        position: fixed;
        right: vh(36);
        z-index: 1;
        top: auto !important;
        bottom: vh(40) !important;
        transform: none !important;

        .swiper-pagination-bullet {
            width: vh(17);
            height: vh(17);
            margin: vh(10) auto !important;
            border: none;
            box-sizing: content-box;
            opacity: 1;
            background: #fff;

            &.swiper-pagination-bullet-active {
                border: 3px solid #A0A0A0;
                background: #007aff;
            }
        }
    }

    .input-group {
        .input-t {
            width: 450px;

            input, textarea {
                background-color: transparent;
                border: none;
                outline: none;
                box-shadow: none;
                color: #fff;

                &:focus {
                    border: none;
                    outline: none;
                    box-shadow: none;
                }
            }

            textarea {
                height: 200px;
                vertical-align: top;
                padding-top: 12px;
                resize: none;
            }
        }
    }
</style>
<style lang="scss" scoped>
    .container {
        width: vh(1200);
        margin: auto;
    }


    .fadeInUpS {
        animation-name: fadeInUpS;
    }

    @keyframes fadeInUpS {
        0% {
            opacity: 0;
            transform: translate3d(0, vh(-20), 0);
        }
        100% {
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }

    }

    .home-footer-wrapper {
        height: auto !important;

        .app-footer {
            margin-top: 0;
        }
    }

    .home-swiper {
        height: 100vh;

        section {
            height: 100%;
            overflow: hidden;
        }
    }

    .banner-item {
        img {
            width: 100%;
            display: block;
        }
    }

    .line {
        height: vh(4);
    }

    .company-profile {
        position: relative;

        .video-box {
            margin: auto;
            overflow: visible;
            height: 100vh;

            video {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                min-width: 100%;
                min-height: 100%;
                height: auto;
                width: 100%;
            }
        }

        .video-poster {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background-image: url("../../assets/img/home/poster.jpg");
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            opacity: 0;
            visibility: hidden;
            transition: all 1s ease;

            &.visible {
                opacity: 1;
                visibility: visible;
            }
        }

        .desc-box {
            position: absolute;
            top: 0;
            bottom: 0;
            right: vw(290);
            background-color: rgba(0, 0, 0, 0.65);
            padding: vh(100) vw(70) 0;

            .title {
                font-size: vh(40);
                font-weight: bold;
                color: #fff;
                line-height: vh(50);
            }

            .inner {
                width: vh(335);

                .line {
                    display: inline-block;
                }

                .desc {
                    margin-top: vh(70);
                    color: #fff;
                    opacity: 0.8;
                    font-size: vh(16);
                    line-height: vh(30);
                    text-indent: vh(32);
                    font-weight: 500;

                }
            }
        }
    }

    .products {
        position: relative;

        background-image: url("../../assets/img/home/products/bg.jpg");
        background-position: center;
        background-size: cover;

        .mask-bg {
            @include abs-full;
            background-color: rgba(0, 0, 0, 0.3);
            transition: all 0.5s;
        }

        .product-list {
            margin-top: vh(120);
            text-align: center;

            .product-item {
                position: relative;
                display: inline-block;

                img {
                    height: vh(400);
                    display: block;
                }

                .mask {
                    @include abs-full;
                    background-color: rgba(0, 0, 0, 0.3);
                    transition: all 0.5s;
                }

                .name {
                    position: absolute;
                    left: 0;
                    right: 0;
                    bottom: vh(80);
                    color: #fff;
                    text-align: center;
                    font-weight: 500;
                    font-size: vh(28);
                    letter-spacing: 1.25px;
                    transition: all 0.5s;
                    z-index: 11;

                    &:hover {
                        color: $primary-light-color;
                    }
                }

                &:hover {
                    z-index: 111;

                    .mask {
                        outline: vh(10) solid $primary-light-color;
                        background-color: rgba(0, 0, 0, 0);
                    }

                    .name {
                        bottom: 50%;
                        transform: translateY(50%);
                    }
                }
            }
        }
    }

    .section-title {
        margin-top: vh(100);
        text-align: center;
        color: #fff;

        .title {
            font-size: vh(40);
            font-weight: 500;
        }

        .desc {
            opacity: 0.8;
            line-height: vh(28);
            font-weight: 500;
            max-width: 1000px;
            margin: vh(20) auto 0;
        }
    }

    .investor-relations {
        position: relative;

        background-image: url("../../assets/img/home/investor/bg.jpg");
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;

        .section-title {
            .title {
                color: $title-color;
            }
        }

        .top-box {
            width: vh(1200);
            padding: vh(20);
            margin: vh(30) auto 0;
            background-color: #fff;
            @include clearfix;
            @include box-shadow;

            .chart-box {
                float: left;
                width: vh(545);

                img {
                    height: vh(300);
                    display: block;
                }
            }

            .info-box {
                float: right;
                width: vh(500);

                .name {
                    font-size: vh(18);
                    font-weight: bold;
                    margin-bottom: vh(10);
                }

                .now {
                    color: #FF6565;
                    font-size: vh(48);
                    line-height: vh(66);

                    &.down {
                        color: #09a402;
                    }
                }

                .row {
                    margin: vh(20) 0;
                    @include clearfix;

                    .item {
                        width: 33.33%;
                        float: left;
                        color: $text-color;

                        .key {
                            opacity: 0.7;
                            margin-bottom: vh(5);
                        }

                        .value {
                            font-size: vh(30);;
                            font-family: Heiti SC;
                            font-weight: 300;
                            line-height: vh(37);
                        }
                    }
                }
            }
        }

        .bottom-box {
            margin-top: vh(20);

            .title {
                font-size: $font-size-large;
                color: $primary-color;
                display: inline-block;
                line-height: 1;
                font-weight: bold;

                &:before {
                    content: '';
                    display: inline-block;
                    width: 4px;
                    height: 18px;
                    background-color: $primary-color;
                    vertical-align: top;
                    margin-right: 4px;
                }
            }

            .left-box {
                position: relative;
                width: vh(348);
                height: vh(310);
                padding: vh(28) vh(20) vh(20) vh(20);
                float: left;
                background-image: url("../../assets/img/home/investor/1.jpg");
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                @include box-shadow;

                .btn-more {
                    position: absolute;
                    right: vh(20);
                    bottom: vh(20);
                }
            }

            .right-box {
                position: relative;
                width: vh(825);
                height: vh(310);
                padding: vh(28) vh(20) vh(20) vh(20);
                float: right;
                background-color: #fff;
                background-image: url("../../assets/img/home/investor/2.jpg");
                background-position: center;
                background-size: cover;
                background-repeat: no-repeat;
                @include box-shadow;

                .btn-more {
                    position: absolute;
                    right: vh(20);
                    bottom: vh(20);
                }
            }
        }
    }

    .news {
        position: relative;
        height: 1080px;
        background-color: #FAFAFA;

        .bg {
            height: 850px;
            background-image: url("../../assets/img/home/news/bg.jpg");
            background-position: center;
            background-size: cover;
        }

        .inner {
            @include abs-full;
        }

        .section-title {
            .split {
                background-color: #fff;
            }
        }

        .top-news {
            width: vh(1200);
            margin: vh(30) auto 0;
            background-color: #fff;

            .img {
                height: vh(290);
                background-position: center;
                background-size: cover;
            }

            .bar {
                position: relative;
                height: vh(100);
                padding: vh(24) vh(30);

                .title {
                    font-size: vh(18);
                    color: #000000;
                    margin-bottom: vh(10);
                    margin-right: vh(20);
                    display: inline-block;
                }

                .date {
                    color: #666666;
                    font-size: vh(12);
                }

                .subtitle {
                    font-size: vh(14);;
                    color: #666666;
                }

                .btn-more {
                    position: absolute;
                    right: vh(30);
                    bottom: vh(24);
                }
            }
        }

        .bottom-list {
            width: vh(1200);
            height: vh(250);
            margin: auto;
            margin-top: vh(25);
            position: relative;

            .swiper-container {
                height: 100%;
            }

            .swiper-slide {
                display: flex;
                background-color: #fff;
                position: relative;

                .left {
                    width: vh(250);
                    height: vh(250);
                    background-position: center;
                    background-size: cover;
                }

                .right {
                    height: 100%;
                    padding: vh(20) vh(20);
                    width: vh(340);

                    .title {
                        font-size: vh(18);
                        color: #000000;
                        margin-bottom: vh(10);
                        margin-right: vh(20);
                    }

                    .date {
                        color: #666666;
                        font-size: vh(12);
                    }

                    .subtitle {
                        font-size: vh(14);
                        color: #666666;
                        margin-top: vh(27);
                    }

                    .btn-more {
                        position: absolute;
                        right: vh(30);
                        bottom: vh(24);
                    }
                }
            }

            .icon-left {
                position: absolute;
                width: vh(50);
                height: vh(50);
                top: 50%;
                margin-top: vh(-25);
                left: vh(-25);
                background-color: #fff;
                z-index: 11;
                text-align: center;
                border: 1px solid $primary-color;
                cursor: pointer;
                outline: none;

                &:hover {
                    background-color: $primary-color;

                    i {
                        color: #fff;
                    }
                }

                i {
                    font-size: vh(24);
                    color: $primary-color;
                    line-height: vh(50);
                }
            }

            .icon-right {
                cursor: pointer;
                position: absolute;
                width: vh(50);
                height: vh(50);
                top: 50%;
                margin-top: vh(-25);
                right: vh(-25);
                background-color: #fff;
                z-index: 11;
                border: 1px solid $primary-color;
                text-align: center;
                outline: none;

                &:hover {
                    background-color: $primary-color;

                    i {
                        color: #fff;
                    }
                }

                i {
                    font-size: vh(24);
                    color: $primary-color;
                    line-height: vh(50);
                }
            }

        }
    }
</style>
